var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageToolbar',{attrs:{"title":"Audits","icon":"mdi-security","dark":""}}),_c('ListaAudits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }